export const BUTTON_THEMES = {
  default: {
    bg: 'bg-white/80 hover:bg-white',
    text: 'text-gray-600',
    border: 'border-gray-300'
  },
  blue: {
    bg: 'bg-blue-200 hover:bg-blue-300',
    text: 'text-blue-700',
    border: 'border-blue-300'
  },
  green: {
    bg: 'bg-green-200 hover:bg-green-300',
    text: 'text-green-700',
    border: 'border-green-300'
  },
  emerald: {
    bg: 'bg-emerald-200 hover:bg-emerald-300',
    text: 'text-emerald-700',
    border: 'border-emerald-300'
  },
  terminal: {
    bg: 'bg-gray-700 hover:bg-gray-600',
    text: 'text-green-400',
    border: 'border-gray-600'
  },
  gray: {
    bg: 'bg-gray-300 hover:bg-gray-400',
    text: 'text-gray-800',
    border: 'border-gray-400'
  },
  stone: {
    bg: 'bg-stone-200 hover:bg-stone-300',
    text: 'text-stone-700',
    border: 'border-stone-300'
  },
  amber: {
    bg: 'bg-amber-200 hover:bg-amber-300',
    text: 'text-amber-900',
    border: 'border-amber-300'
  },
  orange: {
    bg: 'bg-orange-200 hover:bg-orange-300',
    text: 'text-orange-700',
    border: 'border-orange-300'
  }
};

export const PANEL_THEMES = {
  analysis: {
    background: 'bg-orange-50',
    header: 'bg-orange-100',
    title: 'text-orange-900',
    icon: '📊'
  },
  staffing: {
    background: 'bg-amber-50',
    header: 'bg-amber-100',
    title: 'text-amber-900',
    icon: '👥'
  },
  cost: {
    background: 'bg-gray-100',
    header: 'bg-gray-200',
    title: 'text-gray-900',
    icon: '💰'
  },
  tools: {
    background: 'bg-gray-100',
    header: 'bg-gray-200',
    title: 'text-gray-900',
    icon: '🛠️'
  }
};